/**
 * Budget sidebar badge store.
 * Written by `<BudgetBadgeSubscriber />`; read by `budgetsMenu`.
 */

import { create } from 'zustand';

type BudgetBadgeMetrics =
  | 'pendingBudgetApprovals'
  | 'unacknowledgedAlerts'
  | 'pendingChangeRequests'
  | 'openAnomalies';

interface BudgetBadgesState {
  pendingBudgetApprovals: number;
  unacknowledgedAlerts: number;
  pendingChangeRequests: number;
  /** v3 — anomalies still awaiting review (StatusID 0). */
  openAnomalies: number;
  setFromMetrics: (m: Partial<Pick<BudgetBadgesState, BudgetBadgeMetrics>>) => void;
  applyDelta: (m: Partial<Pick<BudgetBadgesState, BudgetBadgeMetrics>>) => void;
  reset: () => void;
}

const EMPTY = {
  pendingBudgetApprovals: 0,
  unacknowledgedAlerts: 0,
  pendingChangeRequests: 0,
  openAnomalies: 0,
};
const clamp = (n: number) => (n < 0 ? 0 : n);

export const useBudgetBadgesStore = create<BudgetBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) =>
    set({
      pendingBudgetApprovals: clamp(m.pendingBudgetApprovals ?? 0),
      unacknowledgedAlerts: clamp(m.unacknowledgedAlerts ?? 0),
      pendingChangeRequests: clamp(m.pendingChangeRequests ?? 0),
      openAnomalies: clamp(m.openAnomalies ?? 0),
    }),
  applyDelta: (m) =>
    set((state) => ({
      pendingBudgetApprovals: clamp(state.pendingBudgetApprovals + (m.pendingBudgetApprovals ?? 0)),
      unacknowledgedAlerts: clamp(state.unacknowledgedAlerts + (m.unacknowledgedAlerts ?? 0)),
      pendingChangeRequests: clamp(state.pendingChangeRequests + (m.pendingChangeRequests ?? 0)),
      openAnomalies: clamp(state.openAnomalies + (m.openAnomalies ?? 0)),
    })),
  reset: () => set(EMPTY),
}));
